import { useEffect, useState } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import TipoPruebaSelector from '../../components/form/TipoPruebaSelector/TipoPruebaSelector'
import { isAnyBlank } from '../../utils/string'
import css from './ModalEditarTemario.module.css'

const ModalEditarTemario = ({
  open,
  temario,
  onClose,
  onSubmit,
  isLoading
}) => {
  const [datos, setDatos] = useState({
    nombre: '',
    asignaturas: [],
    tipoPrueba: ''
  })

  useEffect(() => {
    setDatos({
      nombre: temario?.nombre || '',
      asignaturas: temario?.asignaturas?.map(asignatura => asignatura.id) || [],
      tipoPrueba: temario?.tipoPrueba || ''
    })
  }, [open, temario])

  const handleSubmit = () => {
    onSubmit({
      temario: temario.id,
      nombre: datos.nombre,
      asignaturas: datos.asignaturas,
      tipo: datos.tipoPrueba
    })
  }

  const isSubmitDisabled = isAnyBlank(datos.nombre)

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Editar temario</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.intro}>
          <TextField
            label='Nombre'
            value={datos.nombre}
            className={css.input}
            variant='standard'
            onChange={e => setDatos({ ...datos, nombre: e.target.value })}
          />
          <AsignaturaSelector
            multiple
            className={css.input}
            name='asignatura'
            label='Asignaturas'
            value={datos.asignaturas}
            onChange={(_e, value) =>
              setDatos({ ...datos, asignaturas: value.map(a => a.id) || [] })
            }
          />
          <TipoPruebaSelector
            className={css.input}
            name='tipoPrueba'
            label='Tipo de Prueba'
            value={datos.tipoPrueba}
            onChange={e => setDatos({ ...datos, tipoPrueba: e.target.value })}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarTemario
